import apiCall from "../services/ApiServerCall";
import apiServiceCall from "../services/ApiServiceCall";


export const registerLoggedUserInServiceBackend =  (requestData) => {
    return  apiServiceCall().post('/citizens',requestData).then(({data}) => data);
}

export const getUser = () => {
    return  apiCall().get('/get/auth/user').then(({data}) => data);
}

// tokenOverride lets the pre-2FA login flow authenticate this call without
// ever writing the token to localStorage, so a refresh mid-2FA doesn't
// auto-log the user in via Auth.jsx before they've entered the OTP code.
export const sendLoginOtp = (tokenOverride) => {
    return apiCall(tokenOverride).post('/otp/send').then(({data}) => data);
}

export const verifyLoginOtp = (code, tokenOverride) => {
    return apiCall(tokenOverride).post('/otp/verify', { code }).then(({data}) => data);
}
